// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__29QYy","messages":"Chat_messages__3JRrc","dateDivider":"Chat_dateDivider__F0mHm"};